import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import NoMatchAnonymous from "../components/NoMatchAnonymous";
import ResetPassword from "../containers/ResetPassword";
import Login from "../containers/Login";
import AnonymousActivity from "../containers/AnonymousActivity";
import Signup from '../containers/Signup';

function UnauthenticatedRouter(props) {
	let { updateHeader, resetHeader, showSnackbar, evictUser, removeBgMask,
		updateSnackbarMessage, loginCallback, loadUserFailed, unauthenticated, location } = props,
		routes = UnauthenticatedRouter.getRoutes();

	return (
		<Switch>
			<Route
				path={routes[2]}
				render={renderProps => {
					removeBgMask();
					return (
						<AnonymousActivity
							{...renderProps}
							location={location}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							unauthenticated={unauthenticated} />
					);
				}} />

			<Route
				path={routes[0]}
				render={renderProps =>
					<ResetPassword
						{...renderProps}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar}
						evictUser={evictUser}
						updateSnackbarMessage={updateSnackbarMessage} />
				} />

			<Route
				path={routes[1]}
				render={renderProps =>
					<Login
						{...renderProps}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar}
						loginCallback={loginCallback}
						loadUserFailed={loadUserFailed} />
				} />

			{/* <Route
				path={routes[3]}
				render={renderProps =>
					<Signup
					{...renderProps}
					updateHeader={updateHeader}
					resetHeader={resetHeader}
					showSnackbar={showSnackbar}
					loginCallback={loginCallback}
					loadUserFailed={loadUserFailed} />
				} /> */}

			<Route
				render={renderProps =>
					<NoMatchAnonymous
						{...renderProps}
						updateHeader={updateHeader}
						resetHeader={resetHeader} />
				} />
		</Switch>
	);
}

UnauthenticatedRouter.getRoutes = () => {
	const routes = [
		"/reset-password/:hash",
		"/login",
		"/v",
		// "/signup"
	];
	return routes;
};

UnauthenticatedRouter.propTypes = {
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	updateSnackbarMessage: PropTypes.func,
	evictUser: PropTypes.func,
	loginCallback: PropTypes.func.isRequired,
	loadUserFailed: PropTypes.func.isRequired,
	removeBgMask: PropTypes.func.isRequired,
	location: PropTypes.object,
	unauthenticated: PropTypes.bool
};

export default UnauthenticatedRouter;